import fetchActions from 'fetchActions'

const actions = ['SET_QUERY']

const subActions = {
  LIST: fetchActions,
}

export default [actions, subActions]
